import React from 'react';
import {SideMenuProps} from './types';
import styled from 'styled-components';
import {
  COLORS,
  ComponentTextStyle,
  ComponentXXSStyling
} from '../styles';
import {LaerdalLogo} from '../assets';
import {Button} from '../Button';
import {MenuItem} from '../MenuItem';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;

  border-top: 1px solid ${COLORS.neutral_200};
`;

const ItemsContainer = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  padding: 8px 16px;
  gap: 10px;
  width: 100%;

  button {
    flex: 1;
  }

  .small & {
    gap: 0;
    flex-direction: column-reverse;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  min-height: 80px;
  padding: 8px 16px;
  background-color: ${COLORS.neutral_20};
  width: 100%;
`;

const NoteContainer = styled.div`
  ${ComponentXXSStyling(ComponentTextStyle.Regular, COLORS.neutral_500)}
`;

export const SideMenuFooter = (props: SideMenuProps) => {

  return (
    <Wrapper>
      {
        !!props.footer?.items?.length &&
        <ItemsContainer>
          {props.footer.items.map((item, index) =>
            <MenuItem key={index} size={props.size} {...item}/>
          )}
        </ItemsContainer>
      }
      {
        !!props.footer?.buttons?.length &&
        <ButtonsContainer>
          {
            props.footer.buttons.map((button, index) =>
              <Button key={index} size={props.size} {...button} >
                {button.label}
              </Button>
            )
          }
        </ButtonsContainer>
      }
      {
        !props.footer?.buttons?.length &&
        <LogoContainer>
          <LaerdalLogo height={'36px'} width={'66px'}/>
          <NoteContainer>{props.footer?.note}</NoteContainer>
        </LogoContainer>
      }

    </Wrapper>
  )
};
